import { render, staticRenderFns } from "./AccountOrganizationsList.vue?vue&type=template&id=de60bfae&"
import script from "./AccountOrganizationsList.vue?vue&type=script&lang=js&"
export * from "./AccountOrganizationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports